import {client} from "./ApiClient";
import {mapServiceUrls} from "../Helpers/Globals";
import {useQuery, useQueryClient} from "react-query";
import {Settings} from "../Settings";

const getServiceProviderConfigurationDefinition = (key, accessKey, providerUid, serviceUrls, serviceIntegrationUid) => {
    return client(serviceUrls.GridApiUrl, `api/v4/${accessKey}/ServiceProvisioning/Definitions/${providerUid}${serviceIntegrationUid ? `?serviceIntegrationUid=${serviceIntegrationUid}` : ''}`)
}

export default function useServiceProviderConfigurationDefinition(accessKey, providerUid, serviceUrls, serviceIntegrationUid) {
    const queryClient = useQueryClient();
    const {status, data, error, refetch } = useQuery(['ServiceProviders', providerUid, serviceIntegrationUid], ({ queryKey }) => {
        const [, providerUidFromKey, serviceIntegrationUidFromKey] = queryKey;
        return getServiceProviderConfigurationDefinition(queryKey, accessKey, providerUidFromKey, mapServiceUrls(serviceUrls), serviceIntegrationUidFromKey)
    }, {enabled: !!accessKey && !!serviceUrls, staleTime: 1000*10})
    const providerConfig = data ? data.data : undefined
    const refetchWithIntegrationUid = async (uid) => {
        const key = ['ServiceProviders', providerUid, uid]
        await queryClient.invalidateQueries(key)
        return queryClient.refetchQueries(key)
    }
    return {status, providerConfig, error, refetch, refetchWithIntegrationUid}
}